import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";

import "./Blog.css";

const BlogShow = () => {
  const { id } = useParams(); // Fetch the ID from URL parameters
  const [blog, setBlog] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchBlog = async () => {
      try {
        const response = await axios.get(
          `https://maincompanybackend.metablocktechnologies.org/api/v1/artical/${id}`
        );
        if (
          response.data.message === "No blogs found for the selected category"
        ) {
          setError("No blogs found for this ID.");
        } else {
          setBlog(response.data); // Set blog data
        }
      } catch (err) {
        console.error("Error fetching blog data:", err);
        setError(
          "Failed to fetch blog data. Please check the ID or try again later."
        );
      } finally {
        setLoading(false); // Stop loading
      }
    };

    fetchBlog();
  }, [id]);

  // Display a loading message while data is being fetched
  if (loading) return <p>Loading...</p>;

  // Display an error message if the fetch fails
  if (error) return <p>{error}</p>;

  return (
    <div>
      {/* Title Bar */}
      <div className="titlebar titlebar-sm scheme-dark bg-gray-2 bb-fade-black-005">
        <div className="titlebar-inner py-5">
          <div className="container titlebar-container">
            <div className="row titlebar-container">
              <h1 className="ourtopheadingblog">Our Blogs</h1>
            </div>
          </div>
        </div>
      </div>

      {/* Content Section */}
      <section id="content">
        <div className="content-wrap pb-0">
          <div className="container clearfix">
            <div className="row">
              <div className="col-md-8">
                <div className="single-post nobottommargin">
                  <div
                    style={{ marginTop: "15px" }}
                    className="titlebar-col col-md-12"
                  >
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        justifyContent: "flex-start",
                      }}
                      className="font-size-14 text-fade-dark-06"
                    >
                      <h1
                        style={{ fontSize: "40px", fontFamily: "serif" }}
                        className="font-size-26 mb-1"
                      >
                        {blog?.title}{" "}
                      </h1>
                    </div>
                  </div>
                  {/* Blog Image */}
                  <div className="">
                    <img
                      style={{ margin: "0 auto", marginTop: "10px" }}
                      src={`https://maincompanybackend.metablocktechnologies.orgblogArtical/images/${blog?.image}`}
                      alt={blog.title || "Blog Image"}
                      className="img-responsive"
                    />
                  </div>
                  {/* Blog Content */}
                  <div className="entry clearfix">
                    <div
                      style={{ padding: "30px" }}
                      className="entry-content notopmargin"
                    >
                      <p
                        style={{
                          fontFamily: "arial",
                          fontSize: "20px",
                          color: "white",
                        }}
                      >
                        {blog?.description}
                      </p>
                    </div>
                    <div className="clear" />
                  </div>
                </div>
              </div>

              {/* Sidebar */}
              <div className="col-md-3 col-md-offset-1 sidebar-container">
                <aside className="main-sidebar"></aside>
                <div className="aside-block">
                  <h3 className="aside-title">Tags</h3>
                  <ul className="aside-tags list-unstyled">
                    {blog?.tags?.length > 0 ? (
                      blog.tags.map((tag, index) => (
                        <li key={index}>
                          <b className="text-blue-800">#</b>
                          {tag}
                        </li>
                      ))
                    ) : (
                      <li>No tags available</li>
                    )}
                  </ul>
                </div>
              </div>
              {/* End Sidebar */}
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default BlogShow;

// import React, { useState } from "react";
// import { convertToIST } from "../../helper/formatFunctions";
// import { useParams } from "react-router-dom";
// import axios from "axios";
// import "./Blog.css";

// const Blogshow = () => {

//   const blogPosts = [
//     {
//       _id: "66190f1f6e51fb707927efc1",
//       heading: "A Public Health Concern Youth",
//       subHeading: "asdfasdf",
//       tags: ["#MetaBlockTechnologies", "#Website", "#mobilegames", "#Blockchain"],
//       description:
//         `<h1>Substance Abuse Among Youth: A Public Health Concern</h1><p>Substance abuse among youth is... (Full HTML content here)</p>`,
//       images: [
//         "https://www.djjs.org/uploads/blog/99ad5ffb1fc78d7d4603cf51290a9eb6.png",
//         "https://maincompanybackend.metablocktechnologies.orgfiles/images/image-1712900978416-133783390.png",
//       ],
//       category: "Sample Category",
//       firstSubCategory: "First Subcategory",
//       secondSubCategory: "Second Subcategory",
//       thirdSubCategory: "",
//       fourthSubCategory: "asdf",
//       fifthSubCategory: "asdf",
//       author: "Jayesh Vijay",
//       createdAt: "2024-04-12T10:38:23.367Z",
//       updatedAt: "2024-04-12T10:38:23.367Z",
//     },
//   ];

//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   return (
//     <div>

//       <div key={blogPosts[0]?._id}>
//         {/* Title Bar */}
//         <div className="titlebar titlebar-sm scheme-dark bg-gray-2 bb-fade-black-005">
//           <div className="titlebar-inner py-5">
//             <div className="container titlebar-container">
//               <div className="row titlebar-container">
//                 <div style={{ marginTop: "100px" }} className="titlebar-col col-md-6">
//                   <h1 style={{ textAlign: "start" }} className="font-size-26 mb-1">
//                     {blogPosts[0]?.heading}
//                   </h1>
//                   <div className="font-size-14 text-fade-dark-06">
//                     <ul className="entry-meta clearfix">
//                       <li>{convertToIST(blogPosts[0]?.createdAt)}</li>
//                     </ul>
//                   </div>
//                 </div>
//                 <div className="titlebar-col col-md-6 text-md-right">
//                   <ol className="breadcrumb reset-ul inline-nav">
//                     <li>
//                       <a><span>Home</span></a>
//                     </li>
//                     <li>
//                       <a><span>Blog</span></a>
//                     </li>
//                   </ol>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Content Section */}
//         <section id="content">
//           <div className="content-wrap pb-0">
//             <div className="container clearfix">
//               <div className="row">
//                 <div className="col-md-8">
//                   <div className="single-post nobottommargin">
//                     <div className="pull-left addthis_toolbox addthis_default_style">
//                       <a className="addthis_button_facebook_like" />
//                       <a className="addthis_button_tweet" />
//                       <a className="addthis_button_google_plusone" />
//                       <a className="addthis_counter addthis_pill_style" />
//                     </div>

//                     <div className="mb-3">
//                       <img
//                         style={{ margin: "0 auto" }}
//                         src={blogPosts[0]?.images[0]}
//                         alt={blogPosts[0]?.heading}
//                         className="img-responsive"
//                       />
//                     </div>
//                     <div className="entry clearfix">
//                       <div className="clearfix" />
//                       <div className="entry-content notopmargin">
//                         <div
//                           dangerouslySetInnerHTML={{
//                             __html: blogPosts[0]?.description,
//                           }}
//                         />
//                         <div className="tagcloud clearfix">
//                           <span style={{ marginRight: 10 }} className="pull-left">
//                             <strong>TAGS</strong>
//                           </span>
//                           {blogPosts[0].tags.map((tag, i) => (
//                             <a key={i} href={`#${tag}`}>
//                               {tag}
//                             </a>
//                           ))}
//                         </div>
//                         <div className="clear" />
//                       </div>
//                     </div>
//                   </div>
//                 </div>

//                 {/* Sidebar */}
//                 <div className="col-md-3 col-md-offset-1 sidebar-container">
//                   <aside className="main-sidebar"></aside>
//                   <div className="aside-block">
//                     <h3 className="aside-title">Tags</h3>
//                     <ul className="aside-tags list-unstyled">
//                       <li>Ai</li>
//                       <li>Metaverse</li>
//                       <li>Cryptocurrency Exchange</li>
//                       <li>Cryptocurrency Wallet</li>
//                       <li>Game Development</li>
//                       <li>WEB 3</li>
//                     </ul>
//                   </div>
//                 </div>
//                 {/* End Sidebar */}
//               </div>
//             </div>
//           </div>
//         </section>
//       </div>

//       {/* Comments Section */}

//     </div>
//   );
// };

// export default Blogshow;
